import 'react-dropzone-uploader/dist/styles.css';
import React, { Component } from 'react';
import Toast from './Toast';

class Utilities extends Component {
  constructor(props) {
    super(props);
    this.state = {
      successMessage: '',
      errorMessage: '',
      processing: false,
    };
  }

  async CreatePDF() {
    try {
      await this.setState({processing: true});
      var binary = atob(this.state.base64Text);
      var array = [];
      for (var j = 0; j < binary.length; j++) {
        array.push(binary.charCodeAt(j));
      }
      var file = new Blob([new Uint8Array(array)]);

      // this code below will download the file we selected
      const url = URL.createObjectURL(file);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'Generated.pdf';
      a.click();
      URL.revokeObjectURL(url);
      this.setState({processing: false});
    } 
    catch {
      this.setState({processing: false, errorMessage: 'Failed to Generate PDF File!'})
    }
  }

  EncodeText() {
    try { 
      const b64 = btoa(this.state.textToEncode); 
      this.setState({textToDecode: b64});
    } 
    catch { 
      this.setState({errorMessage: "Unable to Encode String. It May Contain Invalid Characters"});
    }
  }

  DecodeText() {
    try { 
      const str = atob(this.state.textToDecode); 
      this.setState({textToEncode: str});
    } 
    catch { 
      this.setState({errorMessage: "Unable to Decode String. It May Contain Invalid Characters"});
    }
  }

  captureInput = e => {
    this.setState({ [e.target.name]: e.target.value });
  };

  render() {
    return (
      <div className="container">
        <h4>Utilities (Tools)</h4>

        <div className="row mt-4">
          <h5>Base64 Text to PDF</h5>
          <div className="col-md-11">
            <textarea
              className="form-control"
              id="base64Text"
              name="base64Text"
              style={{height:'300px', overflowY:'scroll', wrap:'hard', wordBreak:'break-all', wordWrap:'break-word'}}
              value={this.state.base64Text}
              onChange={this.captureInput}
            />
          </div>
          <div className="col-md-2 mt-2">
            <button
              disabled={!this.state.base64Text || this.state.processing}
              className="btn btn-primary"
              onClick={() => this.CreatePDF()}
            >
              Create PDF
            </button>
          </div>
        </div>

        <div className="row mt-4">
          <h5>Encode/Decode Base64</h5>

          <div className="col-md-11">
            <div>Encode:</div>
            <textarea
              className="form-control"
              id="textToEncode"
              name="textToEncode"
              style={{height:'150px', overflowY:'scroll', wrap:'hard', wordBreak:'break-all', wordWrap:'break-word'}}
              value={this.state.textToEncode}
              onChange={this.captureInput}
            />
          </div>

          <div className="col-md-2 mt-2">
            <button
              className="btn btn-primary"
              onClick={() => this.EncodeText()}
              disabled={!this.state.textToEncode}
            >
              Encode
            </button>
          </div>

          <div className="col-md-11 mt-4">
            <div>Decode:</div>
            <textarea
              className="form-control"
              id="textToDecode"
              name="textToDecode"
              style={{height:'150px', overflowY:'scroll', wrap:'hard', wordBreak:'break-all', wordWrap:'break-word'}}
              value={this.state.textToDecode}
              onChange={this.captureInput}
            />
          </div>

          <div className="col-md-2 mt-2">
            <button
              className="btn btn-primary"
              onClick={() => this.DecodeText()}
              disabled={!this.state.textToDecode}
            >
              Decode
            </button>
          </div>
        </div>

        {/* <div className="row mt-4">
          <h5>FileName to ByteID</h5>

        </div> */}

        {/* <div className="row mt-4">
          <h5>Replace Ratesheet (old with mistake - replace with new)</h5>

        </div> */}

        {this.state.successMessage && (
          <Toast
            type="success"
            title={this.state.successMessage}
            onClose={() => this.setState({ successMessage: '' })}
          />
        )}
        {this.state.errorMessage && (
          <Toast
            type="danger"
            title={this.state.errorMessage}
            onClose={() => this.setState({ errorMessage: '' })}
          />
        )}
      </div>
    );
  }
}
export default Utilities;
